import { objectOf, arrayOf, maybe, recordOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isPostApiCalculatedAttributesAppGroupIdArchiveResult = objectOf({
  success_ids: arrayOf(string),
  error_ids: arrayOf(string),
  error_id_to_reason: recordOf<Record<string, string>>(string),
  error_id_to_code: maybe(recordOf<Record<string, string>>(string)),
});
